import React from 'react'

import { HeaderProps } from '@enuygun/frontend-components'
import {
  BusTicket,
  Car,
  CarTime,
  ContactPhone,
  DownloadMobile,
  EnCuzdanim,
  Faq,
  Finance,
  FlightTicket,
  GiftCard,
  Headset,
  Hotels,
  InfoCircleOutline,
  Internet,
  PercentIcon,
  Phone,
  ProfileIcons,
  Sigortalar,
  ThreeDots,
  TicketCancel,
  TravelInsurance,
} from '@enuygun/icons'

//@ts-ignore
export const defaultMobileLinks: HeaderProps['mobileNavigationItems']['sections'] = [
  [
    {
      href: 'https://www.enuygun.com/ucak-bileti/',
      title: 'Uçak Bileti',
      icon: <FlightTicket />,
    },
    {
      href: 'https://www.enuygun.com/otel/',
      title: 'Otel',
      icon: <Hotels width={20} />,
    },
    {
      href: 'https://www.enuygun.com/otobus-bileti/',
      title: 'Otobüs Bileti',
      icon: <BusTicket />,
    },
    {
      title: 'Araç Kiralama',
      href: 'https://www.enuygun.com/arac-kiralama/',
      icon: <Car />,
      sub: [
        {
          title: 'Rezervasyon Sorgula',
          href: 'https://www.enuygun.com/arac-kiralama/rezervasyon-sorgulama',
        },
        {
          title: 'Rezervasyon İptali',
          href: 'https://www.enuygun.com/arac-kiralama/rezervasyon-iptal',
        },
      ],
      type: 'submenu',
    },
    {
      title: 'Transfer',
      href: 'https://www.enuygun.com/transfer/',
      icon: <CarTime width={20} height={20} />,
    },
    {
      title: 'Hediye Kart',
      href: 'https://www.enuygun.com/enuygun-hediye-kart/',
      icon: <GiftCard height={21} width={25} />,
    },
    {
      title: 'Kampanyalar',
      href: 'https://www.enuygun.com/kampanyalar/',
      icon: <PercentIcon height={21} width={25} />,
    },
    {
      title: 'Seyahat Sigortası',
      href: 'https://www.enuygunsigorta.com/seyahat-sigortasi/',
      icon: <TravelInsurance height={20} width={17} />,
    },
    {
      title: 'Diğer Servisler',
      icon: <ThreeDots height={4} width={20} />,
      sub: [
        {
          title: 'Finans',
          href: 'https://www.enuygunfinans.com/',
          icon: <Finance height={20} width={20} />,
        },
        {
          title: 'Sigortalar',
          href: 'https://www.enuygunsigorta.com/',
          icon: <TravelInsurance height={20} width={17} />,
        },
        {
          title: 'İnternet Bağlantıları',
          href: 'https://www.enuygun.com/internet-baglantilari/',
          icon: <Internet width={20} height={20} />,
        },
        {
          title: 'GSM Tarifeleri',
          href: 'https://www.enuygun.com/gsm/',
          icon: <Phone width={20} height={20} />,
        },
        {
          title: 'Enuygun Blog',
          href: 'https://www.enuygun.com/bilgi/',
          icon: <InfoCircleOutline width={22} height={22} />,
        },
      ],
      type: 'dialog',
    },
  ],
  [
    {
      href: 'https://www.enuygun.com/ucak-bileti/bilet-iptal-guvencesi/',
      title: 'Bilet İptal Güvencesi',
      icon: <TicketCancel width={20} height={20} />,
    },
  ],
]

export const defaultHeaderDesktopLinks = [
  {
    title: 'Uçak Bileti',
    displayTitle: 'Uçak Bileti',
    href: 'https://www.enuygun.com/ucak-bileti/',
  },
  {
    title: 'Otel',
    displayTitle: 'Otel',
    href: 'https://www.enuygun.com/otel/',
  },
  {
    title: 'Otobüs Bileti',
    displayTitle: 'Otobüs',
    href: 'https://www.enuygun.com/otobus-bileti/',
  },
  {
    title: 'Araç Kiralama',
    displayTitle: 'Araç',
    href: 'https://www.enuygun.com/arac-kiralama/',
  },
  {
    title: 'Transfer',
    displayTitle: 'Transfer',
    href: 'https://www.enuygun.com/transfer/',
  },

  {
    title: 'Yardım',
    href: 'https://www.enuygun.com/yardim/ ',
  },
]

export const defaultMoreDesktopLinks = [
  [
    {
      title: 'Sigorta',
      href: 'https://www.enuygunsigorta.com/',
      rel: 'noopener noreferrer',
      target: '_blank',
      icon: <Sigortalar width={20} height={20} />,
    },
    {
      title: 'Finans',
      href: 'https://www.enuygunfinans.com/',
      icon: <Finance height={20} width={20} />,
    },
    {
      title: 'Kart Puanlarını Aktar',
      href: 'https://www.enuygun.com/kredi-karti-puanlari/',
      icon: <EnCuzdanim height={20} width={20} />,
    },

    {
      title: 'Hediye Kart',
      href: 'https://www.enuygun.com/enuygun-hediye-kart/',
      icon: <GiftCard height={22} width={22} />,
    },
    {
      title: 'Kampanyalar',
      href: 'https://www.enuygun.com/kampanyalar/',
      icon: <PercentIcon height={21} width={25} />,
    },
    {
      title: 'İnternet',
      href: 'https://www.enuygun.com/internet-baglantilari/',
      icon: <Internet width={20} height={20} />,
    },
    {
      title: 'GSM',
      href: 'https://www.enuygun.com/gsm/',
      icon: <Phone width={20} height={20} />,
    },
    {
      title: 'Enuygun Blog',
      href: 'https://www.enuygun.com/bilgi/',
      icon: <ProfileIcons width={20} height={20} />,
    },
    {
      title: 'İletişim',
      href: 'https://www.enuygun.com/iletisim/',
      icon: <Headset width={20} height={20} />,
    },
  ],
]

const WingieDesktopLinksEnglish = [
  {
    title: 'FAQ',
    href: '{{URL}}/faq/',
  },
  {
    title: 'Contact',
    href: '{{URL}}/contact/',
  },
]
const WingieDesktopLinksArabic = [
  {
    title: 'الأسئلة المتكررة',
    href: '{{URL}}/faq/',
  },
  {
    title: 'التواصل',
    href: '{{URL}}/contact/',
  },
]

const WingieDesktopLinksSpanish = [
  {
    title: 'FAQ',
    href: '{{URL}}/faq/',
  },
  {
    title: 'Contacto',
    href: '{{URL}}/contacto/',
  },
]

const WingieDesktopLinksRussian = [
  {
    title: 'FAQ',
    href: '{{URL}}/faq/',
  },

  {
    title: 'Контакты',
    href: '{{URL}}/contact/',
  },
]

const WingieDesktopLinksGerman = [
  {
    title: 'FAQ',
    href: '{{URL}}/faq/',
  },

  {
    title: 'Kontakt',
    href: '{{URL}}/kontakt/',
  },
]

const WingieDesktopLinksAzerbaijani = [
  {
    title: 'Əlaqə',
    href: '{{URL}}/contact/',
  },
]

const WingieDesktopLinksItalian = [
  // {
  //   title: 'FAQ',
  //   href: '{{URL}}/faq/',
  // },
  {
    title: 'Contatto',
    href: '{{URL}}/contact/',
  },
]

const WingieDesktopLinksFrench = [
  // {
  //   title: 'FAQ',
  //   href: '{{URL}}/faq/',
  // },
  {
    title: 'Contact',
    href: '{{URL}}/contact/',
  },
]

const WingieDesktopLinksPortuguese = [
  // {
  //   title: 'FAQ',
  //   href: '{{URL}}/faq/',
  // },
  {
    title: 'Contato',
    href: '{{URL}}/contact/',
  },
]

const WingieDesktopLinksRomanian = [
  // {
  //   title: 'FAQ',
  //   href: '{{URL}}/faq/',
  // },
  {
    title: 'Contact',
    href: '{{URL}}/contact/',
  },
]

const WingieDesktopLinksPolish = [
  // {
  //   title: 'FAQ',
  //   href: '{{URL}}/faq/',
  // },
  {
    title: 'Kontakt',
    href: '{{URL}}/contact/',
  },
]

const WingieDesktopLinksLithuanian = [
  // {
  //   title: 'DUK',
  //   href: '{{URL}}/faq/',
  // },
  {
    title: 'Kontaktai',
    href: '{{URL}}/contact/',
  },
]

const WingieDesktopLinksUzbek = [
  // {
  //   title: 'FAQ',
  //   href: '{{URL}}/faq/',
  // },
  {
    title: 'Aloqa',
    href: '{{URL}}/contact/',
  },
]

const WingieDesktopLinksSerbian = [
  // {
  //   title: 'FAQ',
  //   href: '{{URL}}/faq/',
  // },
  {
    title: 'Kontakt',
    href: '{{URL}}/contact/',
  },
]

const WingieDesktopLinksKyrgyz = [
  // {
  //   title: 'FAQ',
  //   href: '{{URL}}/faq/',
  // },
  {
    title: 'Байланыш',
    href: '{{URL}}/contact/',
  },
]

const WingieDesktopLinksTajik = [
  // {
  //   title: 'FAQ',
  //   href: '{{URL}}/faq/',
  // },
  {
    title: 'Тамос',
    href: '{{URL}}/contact/',
  },
]

const WingieDesktopLinksKazakh = [
  // {
  //   title: 'FAQ',
  //   href: '{{URL}}/faq/',
  // },
  {
    title: 'Байланыс',
    href: '{{URL}}/contact/',
  },
]

const WingieDesktopLinksNetherlands = [
  // {
  //   title: 'Veelgestelde vragen',
  //   href: '{{URL}}/faq/',
  // },
  {
    title: 'Contact',
    href: '{{URL}}/contact/',
  },
]

const WingieDesktopLinksChinese = [
  {
    title: '联系方式',
    href: '{{URL}}/contact/',
  },
]

const WingieDesktopLinksGeorgian = [
  {
    title: 'კონტაქტი',
    href: '{{URL}}/contact/',
  },
]

const WingieDesktopLinksHindi = [
  {
    title: 'संपर्क करें',
    href: '{{URL}}/contact/',
  },
]

const WingieDesktopLinksJapanese = [
  {
    title: 'お問い合わせ',
    href: '{{URL}}/contact/',
  },
]

const WingieDesktopLinksKorean = [
  {
    title: '연락처',
    href: '{{URL}}/contact/',
  },
]

const WingieDesktopLinksUrdu = [
  {
    title: 'رابطہ کریں',
    href: '{{URL}}/contact/',
  },
]

const WingieDesktopLinksTamil = [
  {
    title: 'தொடர்பு',
    href: '{{URL}}/contact/',
  },
]

const WingieDesktopLinksThai = [
  {
    title: 'ติดต่อเรา',
    href: '{{URL}}/contact/',
  },
]

export const WINGIE_DESKTOP_LINKS = {
  en: WingieDesktopLinksEnglish,
  de: WingieDesktopLinksGerman,
  ar: WingieDesktopLinksArabic,
  es: WingieDesktopLinksSpanish,
  ru: WingieDesktopLinksRussian,
  az: WingieDesktopLinksAzerbaijani,
  it: WingieDesktopLinksItalian,
  fr: WingieDesktopLinksFrench,
  pt: WingieDesktopLinksPortuguese,
  ro: WingieDesktopLinksRomanian,
  pl: WingieDesktopLinksPolish,
  lt: WingieDesktopLinksLithuanian,
  nl: WingieDesktopLinksNetherlands,
  uz: WingieDesktopLinksUzbek,
  sr: WingieDesktopLinksSerbian,
  ky: WingieDesktopLinksKyrgyz,
  tg: WingieDesktopLinksTajik,
  kk: WingieDesktopLinksKazakh,
  zh: WingieDesktopLinksChinese,
  ka: WingieDesktopLinksGeorgian,
  hi: WingieDesktopLinksHindi,
  ja: WingieDesktopLinksJapanese,
  ko: WingieDesktopLinksKorean,
  ur: WingieDesktopLinksUrdu,
  ta: WingieDesktopLinksTamil,
  th: WingieDesktopLinksThai,
}

const WingieGlobalMenuItemsAzerbaijani = [
  {
    title: 'Enuygun Haqqında',
    href: '{{URL}}/about-us/',
    icon: <InfoCircleOutline width={24} height={24} style={{ transform: 'scale(0.82)' }} />,
  },
  {
    title: 'Əlaqə',
    href: '{{URL}}/contact/',
    icon: <ContactPhone width={20} height={20} />,
  },
  {
    title: 'Tətbiqi yüklə',
    href: '{{URL}}/mobile-app/download/',
    icon: <DownloadMobile width={24} height={24} />,
  },
]

const WingieGlobalMenuItemsEnglish = [
  {
    title: 'FAQ',
    href: '{{URL}}/faq/',
    icon: <Faq width={20} height={20} />,
  },
  {
    title: 'About Wingie',
    href: '{{URL}}/about-us/',
    icon: <InfoCircleOutline width={24} height={24} style={{ transform: 'scale(0.82)' }} />,
  },
  {
    title: 'Contact',
    href: '{{URL}}/contact/',
    icon: <ContactPhone width={20} height={20} />,
  },
  {
    title: 'Download App',
    href: '{{URL}}/mobile-app/download/',
    icon: <DownloadMobile width={24} height={24} />,
  },
]
const WingieGlobalMenuItemsGerman = [
  {
    title: 'Häufig gestellte Fragen',
    href: '{{URL}}/faq/',
    icon: <Faq width={20} height={20} />,
  },
  {
    title: 'Über uns',
    href: '{{URL}}/uber-uns/',
    icon: <InfoCircleOutline width={24} height={24} style={{ transform: 'scale(0.82)' }} />,
  },
  {
    title: 'Kontakt',
    href: '{{URL}}/kontakt/',
    icon: <ContactPhone width={20} height={20} />,
  },
  {
    title: 'Lade App herunter',
    href: '{{URL}}/mobile-app/download/',
    icon: <DownloadMobile width={24} height={24} />,
  },
]
const WingieGlobalMenuItemsArabic = [
  {
    title: 'الأسئلة المتكررة',
    href: '{{URL}}/faq/',
    icon: <Faq width={20} height={20} />,
  },
  {
    title: 'تعرّف علينا',
    href: '{{URL}}/about-us/',
    icon: <InfoCircleOutline width={24} height={24} style={{ transform: 'scale(0.82)' }} />,
  },
  {
    title: 'التواصل',
    href: '{{URL}}/contact/',
    icon: <ContactPhone width={20} height={20} />,
  },
  {
    title: 'قم بتنزيل التطبيق',
    href: '{{URL}}/mobile-app/download/',
    icon: <DownloadMobile width={24} height={24} />,
  },
]
const WingieGlobalMenuItemsSpanish = [
  {
    title: 'Preguntas más frecuentes',
    href: '{{URL}}/faq/',
    icon: <Faq width={20} height={20} />,
  },
  {
    title: 'Sobre nosotros',
    href: '{{URL}}/acerca-de-nosotros/',
    icon: <InfoCircleOutline width={24} height={24} style={{ transform: 'scale(0.82)' }} />,
  },
  {
    title: 'Contacto',
    href: '{{URL}}/contacto/',
    icon: <ContactPhone width={20} height={20} />,
  },
  {
    title: 'Descargar aplicación',
    href: '{{URL}}/mobile-app/download/',
    icon: <DownloadMobile width={24} height={24} />,
  },
]
const WingieGlobalMenuItemsRussian = [
  {
    title: 'Часто задаваемые вопросы',
    href: '{{URL}}/faq/',
    icon: <Faq width={20} height={20} />,
  },
  {
    title: 'О нас',
    href: '{{URL}}/about-us/',
    icon: <InfoCircleOutline width={24} height={24} style={{ transform: 'scale(0.82)' }} />,
  },
  {
    title: 'Контакты',
    href: '{{URL}}/contact/',
    icon: <ContactPhone width={20} height={20} />,
  },
  {
    title: 'скачать приложение',
    href: '{{URL}}/mobile-app/download/',
    icon: <DownloadMobile width={24} height={24} />,
  },
]

const WingieGlobalMenuItemsItalian = [
  // {
  //   title: 'FAQ',
  //   href: '{{URL}}/faq/',
  //   icon: <Faq width={20} height={20} />,
  // },
  {
    title: 'Chi siamo',
    href: '{{URL}}/about-us/',
    icon: <InfoCircleOutline width={24} height={24} style={{ transform: 'scale(0.82)' }} />,
  },
  {
    title: 'Contatto',
    href: '{{URL}}/contact/',
    icon: <ContactPhone width={20} height={20} />,
  },
  {
    title: 'Scarica App',
    href: '{{URL}}/mobile-app/download/',
    icon: <DownloadMobile width={24} height={24} />,
  },
]

const WingieGlobalMenuItemsFrench = [
  // {
  //   title: 'FAQ',
  //   href: '{{URL}}/faq/',
  //   icon: <Faq width={20} height={20} />,
  // },
  {
    title: 'À propos de nous',
    href: '{{URL}}/about-us/',
    icon: <InfoCircleOutline width={24} height={24} style={{ transform: 'scale(0.82)' }} />,
  },
  {
    title: 'Contact',
    href: '{{URL}}/contact/',
    icon: <ContactPhone width={20} height={20} />,
  },
  {
    title: 'Télécharger App',
    href: '{{URL}}/mobile-app/download/',
    icon: <DownloadMobile width={24} height={24} />,
  },
]

const WingieGlobalMenuItemsPortuguese = [
  // {
  //   title: 'FAQ',
  //   href: '{{URL}}/faq/',
  //   icon: <Faq width={20} height={20} />,
  // },
  {
    title: 'Sobre nós',
    href: '{{URL}}/about-us/',
    icon: <InfoCircleOutline width={24} height={24} style={{ transform: 'scale(0.82)' }} />,
  },
  {
    title: 'Contato',
    href: '{{URL}}/contact/',
    icon: <ContactPhone width={20} height={20} />,
  },
  {
    title: 'Baixar App',
    href: '{{URL}}/mobile-app/download/',
    icon: <DownloadMobile width={24} height={24} />,
  },
]

const WingieGlobalMenuItemsRomanian = [
  // {
  //   title: 'FAQ',
  //   href: '{{URL}}/faq/',
  //   icon: <Faq width={20} height={20} />,
  // },
  {
    title: 'Despre noi',
    href: '{{URL}}/about-us/',
    icon: <InfoCircleOutline width={24} height={24} style={{ transform: 'scale(0.82)' }} />,
  },
  {
    title: 'Contact',
    href: '{{URL}}/contact/',
    icon: <ContactPhone width={20} height={20} />,
  },
  {
    title: 'Descarcă App',
    href: '{{URL}}/mobile-app/download/',
    icon: <DownloadMobile width={24} height={24} />,
  },
]

const WingieGlobalMenuItemsPolish = [
  // {
  //   title: 'FAQ',
  //   href: '{{URL}}/faq/',
  //   icon: <Faq width={20} height={20} />,
  // },
  {
    title: 'O nas',
    href: '{{URL}}/about-us/',
    icon: <InfoCircleOutline width={24} height={24} style={{ transform: 'scale(0.82)' }} />,
  },
  {
    title: 'Kontakt',
    href: '{{URL}}/contact/',
    icon: <ContactPhone width={20} height={20} />,
  },
  {
    title: 'Pobierz aplikację',
    href: '{{URL}}/mobile-app/download/',
    icon: <DownloadMobile width={24} height={24} />,
  },
]

const WingieGlobalMenuItemsLithuanian = [
  // {
  //   title: 'DUK',
  //   href: '{{URL}}/faq/',
  //   icon: <Faq width={20} height={20} />,
  // },
  {
    title: 'Apie mus',
    href: '{{URL}}/about-us/',
    icon: <InfoCircleOutline width={24} height={24} style={{ transform: 'scale(0.82)' }} />,
  },
  {
    title: 'Kontaktai',
    href: '{{URL}}/contact/',
    icon: <ContactPhone width={20} height={20} />,
  },
  {
    title: 'Atsisiųsti programą',
    href: '{{URL}}/mobile-app/download/',
    icon: <DownloadMobile width={24} height={24} />,
  },
]

const WingieGlobalMenuItemsUzbek = [
  // {
  //   title: 'FAQ',
  //   href: '{{URL}}/faq/',
  //   icon: <Faq width={20} height={20} />,
  // },
  {
    title: 'Biz haqimizda',
    href: '{{URL}}/about-us/',
    icon: <InfoCircleOutline width={24} height={24} style={{ transform: 'scale(0.82)' }} />,
  },
  {
    title: 'Aloqa',
    href: '{{URL}}/contact/',
    icon: <ContactPhone width={20} height={20} />,
  },
  {
    title: 'Ilovani yuklab olish',
    href: '{{URL}}/mobile-app/download/',
    icon: <DownloadMobile width={24} height={24} />,
  },
]

const WingieGlobalMenuItemsSerbian = [
  // {
  //   title: 'FAQ',
  //   href: '{{URL}}/faq/',
  //   icon: <Faq width={20} height={20} />,
  // },
  {
    title: 'O nama',
    href: '{{URL}}/about-us/',
    icon: <InfoCircleOutline width={24} height={24} style={{ transform: 'scale(0.82)' }} />,
  },
  {
    title: 'Kontakt',
    href: '{{URL}}/contact/',
    icon: <ContactPhone width={20} height={20} />,
  },
  {
    title: 'Preuzmi aplikaciju',
    href: '{{URL}}/mobile-app/download/',
    icon: <DownloadMobile width={24} height={24} />,
  },
]

const WingieGlobalMenuItemsKyrgyz = [
  // {
  //   title: 'FAQ',
  //   href: '{{URL}}/faq/',
  //   icon: <Faq width={20} height={20} />,
  // },
  {
    title: 'Биз жөнүндө',
    href: '{{URL}}/about-us/',
    icon: <InfoCircleOutline width={24} height={24} style={{ transform: 'scale(0.82)' }} />,
  },
  {
    title: 'Байланыш',
    href: '{{URL}}/contact/',
    icon: <ContactPhone width={20} height={20} />,
  },
  {
    title: 'Колдонмону жүктөө',
    href: '{{URL}}/mobile-app/download/',
    icon: <DownloadMobile width={24} height={24} />,
  },
]

const WingieGlobalMenuItemsTajik = [
  // {
  //   title: 'FAQ',
  //   href: '{{URL}}/faq/',
  //   icon: <Faq width={20} height={20} />,
  // },
  {
    title: 'Дар бораи мо',
    href: '{{URL}}/about-us/',
    icon: <InfoCircleOutline width={24} height={24} style={{ transform: 'scale(0.82)' }} />,
  },
  {
    title: 'Тамос',
    href: '{{URL}}/contact/',
    icon: <ContactPhone width={20} height={20} />,
  },
  {
    title: 'Барномаро боргирӣ кунед',
    href: '{{URL}}/mobile-app/download/',
    icon: <DownloadMobile width={24} height={24} />,
  },
]

const WingieGlobalMenuItemsKazakh = [
  // {
  //   title: 'FAQ',
  //   href: '{{URL}}/faq/',
  //   icon: <Faq width={20} height={20} />,
  // },
  {
    title: 'Біз туралы',
    href: '{{URL}}/about-us/',
    icon: <InfoCircleOutline width={24} height={24} style={{ transform: 'scale(0.82)' }} />,
  },
  {
    title: 'Байланыс',
    href: '{{URL}}/contact/',
    icon: <ContactPhone width={20} height={20} />,
  },
  {
    title: 'Қолданбаны жүктеу',
    href: '{{URL}}/mobile-app/download/',
    icon: <DownloadMobile width={24} height={24} />,
  },
]

const WingieGlobalMenuItemsNetherlands = [
  // {
  //   title: 'Veelgestelde vragen',
  //   href: '{{URL}}/faq/',
  //   icon: <Faq width={20} height={20} />,
  // },
  {
    title: 'Over Wingie',
    href: '{{URL}}/about-us/',
    icon: <InfoCircleOutline width={24} height={24} style={{ transform: 'scale(0.82)' }} />,
  },
  {
    title: 'Contact',
    href: '{{URL}}/contact/',
    icon: <ContactPhone width={20} height={20} />,
  },
  {
    title: 'App downloaden',
    href: '{{URL}}/mobile-app/download/',
    icon: <DownloadMobile width={24} height={24} />,
  },
]

const WingieGlobalMenuItemsChinese = [
  {
    title: '关于 Wingie',
    href: '{{URL}}/about-us/',
    icon: <InfoCircleOutline width={24} height={24} style={{ transform: 'scale(0.82)' }} />,
  },
  {
    title: '联系方式',
    href: '{{URL}}/contact/',
    icon: <ContactPhone width={20} height={20} />,
  },
  {
    title: '下载应用',
    href: '{{URL}}/mobile-app/download/',
    icon: <DownloadMobile width={24} height={24} />,
  },
]

const WingieGlobalMenuItemsGeorgian = [
  {
    title: 'ჩვენ შესახებ',
    href: '{{URL}}/about-us/',
    icon: <InfoCircleOutline width={24} height={24} style={{ transform: 'scale(0.82)' }} />,
  },
  {
    title: 'კონტაქტი',
    href: '{{URL}}/contact/',
    icon: <ContactPhone width={20} height={20} />,
  },
  {
    title: 'აპის ჩამოტვირთვა',
    href: '{{URL}}/mobile-app/download/',
    icon: <DownloadMobile width={24} height={24} />,
  },
]

const WingieGlobalMenuItemsHindi = [
  {
    title: 'हमारे बारे में',
    href: '{{URL}}/about-us/',
    icon: <InfoCircleOutline width={24} height={24} style={{ transform: 'scale(0.82)' }} />,
  },
  {
    title: 'संपर्क करें',
    href: '{{URL}}/contact/',
    icon: <ContactPhone width={20} height={20} />,
  },
  {
    title: 'ऐप डाउनलोड करें',
    href: '{{URL}}/mobile-app/download/',
    icon: <DownloadMobile width={24} height={24} />,
  },
]

const WingieGlobalMenuItemsJapanese = [
  {
    title: '会社概要',
    href: '{{URL}}/about-us/',
    icon: <InfoCircleOutline width={24} height={24} style={{ transform: 'scale(0.82)' }} />,
  },
  {
    title: 'お問い合わせ',
    href: '{{URL}}/contact/',
    icon: <ContactPhone width={20} height={20} />,
  },
  {
    title: 'アプリをダウンロード',
    href: '{{URL}}/mobile-app/download/',
    icon: <DownloadMobile width={24} height={24} />,
  },
]

const WingieGlobalMenuItemsKorean = [
  {
    title: '회사 소개',
    href: '{{URL}}/about-us/',
    icon: <InfoCircleOutline width={24} height={24} style={{ transform: 'scale(0.82)' }} />,
  },
  {
    title: '연락처',
    href: '{{URL}}/contact/',
    icon: <ContactPhone width={20} height={20} />,
  },
  {
    title: '앱 다운로드',
    href: '{{URL}}/mobile-app/download/',
    icon: <DownloadMobile width={24} height={24} />,
  },
]

const WingieGlobalMenuItemsUrdu = [
  {
    title: 'ہمارے بارے میں',
    href: '{{URL}}/about-us/',
    icon: <InfoCircleOutline width={24} height={24} style={{ transform: 'scale(0.82)' }} />,
  },
  {
    title: 'رابطہ کریں',
    href: '{{URL}}/contact/',
    icon: <ContactPhone width={20} height={20} />,
  },
  {
    title: 'ایپ ڈاؤنلوڈ کریں',
    href: '{{URL}}/mobile-app/download/',
    icon: <DownloadMobile width={24} height={24} />,
  },
]

const WingieGlobalMenuItemsTamil = [
  {
    title: 'எங்கள் பற்றி',
    href: '{{URL}}/about-us/',
    icon: <InfoCircleOutline width={24} height={24} style={{ transform: 'scale(0.82)' }} />,
  },
  {
    title: 'தொடர்பு',
    href: '{{URL}}/contact/',
    icon: <ContactPhone width={20} height={20} />,
  },
  {
    title: 'செயலியை பதிவிறக்கவும்',
    href: '{{URL}}/mobile-app/download/',
    icon: <DownloadMobile width={24} height={24} />,
  },
]

const WingieGlobalMenuItemsThai = [
  {
    title: 'เกี่ยวกับเรา',
    href: '{{URL}}/about-us/',
    icon: <InfoCircleOutline width={24} height={24} style={{ transform: 'scale(0.82)' }} />,
  },
  {
    title: 'ติดต่อเรา',
    href: '{{URL}}/contact/',
    icon: <ContactPhone width={20} height={20} />,
  },
  {
    title: 'ดาวน์โหลดแอป',
    href: '{{URL}}/mobile-app/download/',
    icon: <DownloadMobile width={24} height={24} />,
  },
]

export const GLOBAL_MENU_ITEMS = {
  en: WingieGlobalMenuItemsEnglish,
  de: WingieGlobalMenuItemsGerman,
  ar: WingieGlobalMenuItemsArabic,
  es: WingieGlobalMenuItemsSpanish,
  ru: WingieGlobalMenuItemsRussian,
  az: WingieGlobalMenuItemsAzerbaijani,
  it: WingieGlobalMenuItemsItalian,
  fr: WingieGlobalMenuItemsFrench,
  pt: WingieGlobalMenuItemsPortuguese,
  ro: WingieGlobalMenuItemsRomanian,
  pl: WingieGlobalMenuItemsPolish,
  lt: WingieGlobalMenuItemsLithuanian,
  nl: WingieGlobalMenuItemsNetherlands,
  uz: WingieGlobalMenuItemsUzbek,
  sr: WingieGlobalMenuItemsSerbian,
  ky: WingieGlobalMenuItemsKyrgyz,
  tg: WingieGlobalMenuItemsTajik,
  kk: WingieGlobalMenuItemsKazakh,
  zh: WingieGlobalMenuItemsChinese,
  ka: WingieGlobalMenuItemsGeorgian,
  hi: WingieGlobalMenuItemsHindi,
  ja: WingieGlobalMenuItemsJapanese,
  ko: WingieGlobalMenuItemsKorean,
  ur: WingieGlobalMenuItemsUrdu,
  ta: WingieGlobalMenuItemsTamil,
  th: WingieGlobalMenuItemsThai,
}
